export const selectProps = {
  dropdownMatchSelectWidth: false,
  showSearch: true,
  filterOption: (input: string, option: any) => {
    const l = option.children ?? option.label;
    if (!l) return false;
    return l.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  },
};
